import { Controller } from "stimulus"
import i18n from "../../packs/i18n"
import i18next from "i18next";
export default class extends Controller {
  static targets = ["testSelector","stateSelector", "testPrice","fullPrice", "discount", "startDate", "endDate"]
  
  connect(){
    $('.selectpicker').selectpicker();
    $(this.endDateTarget).datepicker()
    $(this.startDateTarget).datepicker()

    i18n.then(()=>{
      this.initValidtion()
    })
  }

  initValidtion(){
     let testPrice = this.testPriceTarget

     $(this.element).validate({
      ignore: [],
      errorPlacement: function(error, element) {
        switch (element.attr("id")) {
          case 'state_price_break_test_id':
            element.parent().parent().append(error);
            break;
          case 'state_price_break_discount':
            element.parent().parent().append(error);
            break;
          case 'state_price_break_state':
            element.parent().parent().append(error);
            break;
          default:
            element.parent().append(error);
            break;
        }
      }
    });

    $(this.testSelectorTarget).each(function () {
      $(this).rules('add', {
        required: true,
        messages: {
          required: i18next.t('required_field')
        }
      });
    })

    $(this.startDateTarget).each(function () {
      $(this).rules('add', {
        required: true,
        messages: {
          required: i18next.t('required_field')
        }
      });

      $(this).rules('add', {
        dateFormat: true,
        messages: {
          dateFormat: i18next.t('valid_data_format')
        }
      });
    });

    $(this.endDateTarget).each(function () {
      $(this).rules('add', {
        required: true,
        messages: {
          required: i18next.t('required_field')
        }
      });
      $(this).rules('add', {
        dateFormat: true,
        messages: {
          dateFormat: i18next.t('valid_data_format')
        }
      });
    });

    $(this.discountTarget).each(function () {
      $(this).rules('add', {
        required: true,
        max: function(){
          return +parseFloat(testPrice.value).toFixed(2)
        },
        messages: {
          required: i18next.t('required_field')
        }
      });
    });

    $(this.stateSelectorTarget).each(function () {
      $(this).rules('add', {
        required: true,
        messages: {
          required: i18next.t('required_field')
        }
      });
    });
  }
}
